React = require('react/addons')
EventItem = require('./event-item')
EventActions = require('../../actions/EventActions')
ReactCSSTransitionGroup = React.addons.CSSTransitionGroup

module.exports = React.createClass

    render: ->
        currentProps = @props

        if @props.items.length <= 0
            list = React.createElement("div", null, "You have no notes currently, please create one.")
        else
            list = @props.items.map((item, key) ->
                deleteCallback = (e) ->
                    e.preventDefault()
                    currentProps.removeItem(item)

                React.createElement(EventItem, { \
                    "onDelete": (deleteCallback),  \
                    "item": (item),  \
                    "editItem": (currentProps.editItem),  \
                    "name": (item.name),  \
                    "description": (item.description)})
            )

        return (
            React.createElement("div", {"className": "events"},
                React.createElement("h1", null, (@props.title)),
                React.createElement("div", {"className": "list"},
                    React.createElement(ReactCSSTransitionGroup, {"transitionName": "list"},
                        (list)
                    )
                )
            )
        )



/** WEBPACK FOOTER **
 ** ./~/cjsx-loader!./src/scripts/components/modules/events.cjsx
 **/